import React from 'react'
import { withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import img1 from '../../images/png/home/steps/image1.png'
import img2 from '../../images/png/home/steps/image2.png'
import img3 from '../../images/png/home/steps/image3.png'

const StepsBlock = ({ t }) => {
    return (
        <div className="home__steps-block">
            <ul className="list">
                <li className="item">
                    <img src={img1} alt="" />
                    <div className="text">
                        <div className="title">{t('_pages._home._steps_block._list._1.title')}</div>
                        <p>{t('_pages._home._steps_block._list._1.article')}</p>
                    </div>
                </li>
                <li className="item">
                    <img src={img2} alt="" />
                    <div className="text">
                        <div className="title">{t('_pages._home._steps_block._list._2.title')}</div>
                        <p>{t('_pages._home._steps_block._list._2.article')}</p>
                    </div>
                </li>
                <li className="item">
                    <img src={img3} alt="" />
                    <div className="text">
                        <div className="title">{t('_pages._home._steps_block._list._3.title')}</div>
                        <p>{t('_pages._home._steps_block._list._3.article')}</p>
                    </div>
                </li>
            </ul>
            <div className="link">
                <Link
                    to="/auth?action=registration"
                    className="try-btn button-style"
                    data-size="lg"
                    data-variant="primary"
                >
                    {t('_pages._home._steps_block.try_for_free')}
                </Link>
            </div>
        </div>
    )
}

export default withTranslation('translations')(StepsBlock)
